<template>
  <div>
    <customer-record-loading v-if="loading" />

    <div v-else-if="currentChatUserIds.length === 0">
      К чату не приписан User ID
    </div>

    <div v-else-if="customerRecords.length === 0">Информация не найдена</div>

    <div v-else-if="customerRecords.length === 1">
      <customer-record :customer-record="customerRecords[0]" />
    </div>

    <div v-else-if="customerRecords.length > 1">
      <div>
        <v-btn @click="showPrevRecord" small>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn @click="showNextRecord" small>
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <customer-record :customer-record="customerRecords[currentRecordIndex]" />
    </div>
  </div>
</template>

<script>
import { getCustomerRecords } from '@/api/finex';
import CustomerRecord from './CustomerRecord.vue';
import CustomerRecordLoading from './CustomerRecordLoading.vue';

export default {
  name: 'CustomerInfoSection',
  components: { CustomerRecord, CustomerRecordLoading },

  data() {
    return {
      customerRecords: [],
      currentRecordIndex: 0,
      loading: false,
    };
  },

  computed: {
    currentChatId() {
      return this.$store.state.chat.currentChatId;
    },

    currentChatUserIds() {
      return this.$store.getters['chat/currentChat']?.userIds || [];
    },

    shouldFetchData() {
      return this.currentChatId !== 0 && this.currentChatUserIds.length !== 0;
    },
  },

  watch: {
    currentChatId() {
      if (this.shouldFetchData) {
        this.fetchData();
      }
    },
  },

  mounted() {
    if (this.shouldFetchData) {
      this.fetchData();
    }
  },

  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.currentRecordIndex = 0;
        const res = await getCustomerRecords({
          userTokens: this.currentChatUserIds,
        });
        this.customerRecords = res.data;
      } catch (error) {
        console.error(error);
        this.customerRecords = [];
      } finally {
        this.loading = false;
      }
    },

    showPrevRecord() {
      if (this.currentRecordIndex === 0) {
        this.currentRecordIndex = this.customerRecords.length - 1;
      }

      const prevRecordIndex = this.currentRecordIndex - 1;
      if (this.customerRecords[prevRecordIndex]) {
        this.currentRecordIndex = prevRecordIndex;
      }
    },

    showNextRecord() {
      const nextRecordIndex = this.currentRecordIndex + 1;

      if (this.customerRecords[nextRecordIndex]) {
        this.currentRecordIndex = nextRecordIndex;
      } else {
        this.currentRecordIndex = 0;
      }
    },
  },
};
</script>
